import { createAction } from "@reduxjs/toolkit";

// Admin Authentication Actions
export const AdminLoginAction = createAction("ADMIN_LOGIN");
export const AdminLogoutAction = createAction("ADMIN_LOGOUT");
export const AdminRegisterAction = createAction("ADMIN_REGISTER");
export const AdminForgotPasswordAction = createAction("ADMIN_FORGOT_PASSWORD");
export const AdminResetPasswordAction = createAction("ADMIN_RESET_PASSWORD");

// Admin Dashboard Actions
export const GetAdminDashboardDataAction = createAction("GET_ADMIN_DASHBOARD_DATA");
export const GetAdminAnalyticsAction = createAction("GET_ADMIN_ANALYTICS");

// User Management Actions
export const GetAllUsersAction = createAction("GET_ALL_USERS");
export const GetUserByIdAction = createAction("GET_USER_BY_ID");
export const CreateUserAction = createAction("CREATE_USER");
export const UpdateUserAction = createAction("UPDATE_USER");
export const DeleteUserAction = createAction("DELETE_USER");
export const BlockUserAction = createAction("BLOCK_USER");
export const UnblockUserAction = createAction("UNBLOCK_USER");
export const GetUserActivityAction = createAction("GET_USER_ACTIVITY");

// Content Management Actions
export const GetAllWeatherDataAction = createAction("GET_ALL_WEATHER_DATA");
export const CreateWeatherDataAction = createAction("CREATE_WEATHER_DATA");
export const UpdateWeatherDataAction = createAction("UPDATE_WEATHER_DATA");
export const DeleteWeatherDataAction = createAction("DELETE_WEATHER_DATA");
export const BulkUpdateWeatherDataAction = createAction("BULK_UPDATE_WEATHER_DATA");

// Subscription Management Actions
export const GetAllSubscriptionsAction = createAction("GET_ALL_SUBSCRIPTIONS");
export const UpdateSubscriptionAction = createAction("UPDATE_SUBSCRIPTION");
export const CancelUserSubscriptionAction = createAction("CANCEL_USER_SUBSCRIPTION");
export const GetSubscriptionAnalyticsAction = createAction("GET_SUBSCRIPTION_ANALYTICS");

// API Keys Management Actions
export const GetAllApiKeysAction = createAction("GET_ALL_API_KEYS");
export const GetApiKeysAction = createAction("GET_API_KEYS");
export const GetApiKeyByIdAction = createAction("GET_API_KEY_BY_ID");
export const CreateApiKeyAction = createAction("CREATE_API_KEY");
export const UpdateApiKeyAction = createAction("UPDATE_API_KEY");
export const DeleteApiKeyAction = createAction("DELETE_API_KEY");
export const ToggleApiKeyStatusAction = createAction("TOGGLE_API_KEY_STATUS");
export const GetApiKeyUsageAction = createAction("GET_API_KEY_USAGE");
export const RevokeApiKeyAction = createAction("REVOKE_API_KEY");
export const GetApiUsageStatsAction = createAction("GET_API_USAGE_STATS");

// Alerts Management Actions
export const GetAllAlertsAction = createAction("GET_ALL_ALERTS");
export const CreateSystemAlertAction = createAction("CREATE_SYSTEM_ALERT");
export const UpdateSystemAlertAction = createAction("UPDATE_SYSTEM_ALERT");
export const DeleteSystemAlertAction = createAction("DELETE_SYSTEM_ALERT");

// Reports Actions
export const GenerateUserReportAction = createAction("GENERATE_USER_REPORT");
export const GenerateUsageReportAction = createAction("GENERATE_USAGE_REPORT");
export const GenerateRevenueReportAction = createAction("GENERATE_REVENUE_REPORT");
export const ExportDataAction = createAction("EXPORT_DATA");

// System Settings Actions
export const GetSystemSettingsAction = createAction("GET_SYSTEM_SETTINGS");
export const UpdateSystemSettingsAction = createAction("UPDATE_SYSTEM_SETTINGS");
export const GetSystemLogsAction = createAction("GET_SYSTEM_LOGS");

// Notifications Actions
export const SendNotificationAction = createAction("SEND_NOTIFICATION");
export const GetNotificationsAction = createAction("GET_NOTIFICATIONS");
export const MarkNotificationReadAction = createAction("MARK_NOTIFICATION_READ");
